export interface IShopSettings {
  shopId: number;
  isShopClosed: boolean;
  shopStartHour: string;
  shopEndHour: string;
  shopOpenHoursInterval: number;
  allowFutureDateOrders: boolean;
  noOfFutureDaysAllowed: number;
  minimumOrderAmount: number;
  minimumCollectionOrderAmount: number;
  weeklyShopClosureDays: string;
  defaultDeliveryCost: number;
  estimatedTimeForDelivery: number;
  estimatedTimeForCollection: number;
  notifyWhatsappNumber: string;
  adminWhatsappNumber: string;
  orderDeliveryRadius: number;
  shopPostcode: string;
  cashPaymentDelivery: boolean;
  cashPaymentCollection: boolean;
  shopTableCount: number;
}

export enum WeekDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}
